import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

class NavigationLink extends Component {

  render() {
    const style = { textDecoration: 'none' };

    return (
      <Link to={this.props.to} style={this.props.style || style}>
        {this.props.children}
      </Link>
    );
  }
}

NavigationLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  style: PropTypes.object,
};

NavigationLink.defaultProps = {
  style: null,
};

export default NavigationLink;



// WEBPACK FOOTER //
// ./src/app/components/navigation-link/navigation-link.js